const dataURItoBlob = (dataURI) => {
  const binary = atob(dataURI.split(',')[1])
  const array = []
  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i))
  }
  return new Blob([new Uint8Array(array)], { type: 'image/jpeg' })
}

const blobToDataURI = (blob, callback) => {
  const fr = new FileReader()
  fr.onload = (e) => {
    callback(e.target.result)
  }
  fr.readAsDataURL(blob)
}

const calculateAspectRatioFit = (srcWidth, srcHeight, minWidth, minHeight) => {
  const ratio = Math.max(minWidth / srcWidth, minHeight / srcHeight)
  return { width: srcWidth * ratio, height: srcHeight * ratio }
}

const bufferBoundingBoxes = (boundingBoxes) => {
  return boundingBoxes?.reduce((acum, boundingBox) => {
    boundingBox.left -= 0.1
    boundingBox.top -= 0.1
    boundingBox.width += 0.2
    boundingBox.height += 0.2

    acum.push(boundingBox)
    return acum
  }, [])
}

const generateImageFromCoordinates = (compareItemFaceObject, imgDurl) => {
  const promise = new Promise((resolve) => {
    const img = new Image()
    img.onerror = () => {
      compareItemFaceObject.image = null
      resolve(compareItemFaceObject)
    }

    img.onload = () => {
      const bufferCanvas = document.createElement('canvas')
      const bCtx = bufferCanvas.getContext('2d')
      let offsetX = img.width * compareItemFaceObject.boundingBox.left
      let offsetY = img.height * compareItemFaceObject.boundingBox.top
      let w = Math.floor(img.width * compareItemFaceObject.boundingBox.width) - 3
      let h = Math.floor(img.height * compareItemFaceObject.boundingBox.height) - 3

      let resizedDimensions

      offsetX = offsetX < 0 ? 0 : offsetX
      offsetY = offsetY < 0 ? 0 : offsetY

      bufferCanvas.height = img.height
      bufferCanvas.width = img.width

      if (h + offsetY > bufferCanvas.height) {
        h = img.height - offsetY
      }
      if (w + offsetX > bufferCanvas.width) {
        w = img.width - offsetX
      }

      if (w < 200 || h < 200) {
        resizedDimensions = calculateAspectRatioFit(w, h, 200, 200)
        bufferCanvas.width = resizedDimensions.width
        bufferCanvas.height = resizedDimensions.height
      } else {
        bufferCanvas.width = w
        bufferCanvas.height = h
      }

      bCtx.drawImage(img, offsetX, offsetY, w, h, 0, 0, bufferCanvas.width, bufferCanvas.height)

      compareItemFaceObject.image = bufferCanvas.toDataURL()

      resolve(compareItemFaceObject)
    }

    img.src = imgDurl
  })
  return promise
}

async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    // eslint-disable-next-line no-await-in-loop
    await callback(array[index], index, array)
  }
}

async function asyncOnload(src) {
  return new Promise((resolve) => {
    const img = document.createElement('img')
    img.crossOrigin = 'anonymous'
    img.onload = () => resolve(img)
    img.src = src
  })
}

const getFacesThumbnails = async (durl, boundingBoxes) => {
  const imagesWithData = []
  const paddedBoundingBoxes = bufferBoundingBoxes(boundingBoxes)

  await asyncForEach(paddedBoundingBoxes, async (boundingBox) => {
    imagesWithData.push(await generateImageFromCoordinates({ boundingBox }, durl))
  })
  return imagesWithData
}

const thumbnailDataURLFromBase64 = async ({ imgDataURL, maxWidth, maxHeight }) => {
  // Max size for thumbnail

  if (typeof maxWidth === 'undefined') maxWidth = 500
  if (typeof maxHeight === 'undefined') maxHeight = 500

  // Create and initialize two canvas
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  const canvasCopy = document.createElement('canvas')
  const copyContext = canvasCopy.getContext('2d')

  // Create original image
  const img = await asyncOnload(imgDataURL)
  // Determine new ratio based on max size
  let ratio = 1
  if (img.width > maxWidth) ratio = maxWidth / img.width
  else if (img.height > maxHeight) ratio = maxHeight / img.height

  // Draw original image in second canvas
  canvasCopy.width = img.width
  canvasCopy.height = img.height
  copyContext.drawImage(img, 0, 0)

  // Copy and resize second canvas to first canvas
  canvas.width = img.width * ratio
  canvas.height = img.height * ratio
  ctx.drawImage(canvasCopy, 0, 0, canvasCopy.width, canvasCopy.height, 0, 0, canvas.width, canvas.height)
  return canvas.toDataURL()
}

export { dataURItoBlob, blobToDataURI, thumbnailDataURLFromBase64, getFacesThumbnails, asyncOnload }
